// Push Notification Service for Admin
import { BACKEND_URL } from '../config/api';

class PushNotificationService {
  constructor() {
    this.permission = 'default';
    this.supported = 'Notification' in window;
  }

  async requestPermission() {
    if (!this.supported) {
      console.warn('Push notifications not supported');
      return false;
    }

    try {
      this.permission = await Notification.requestPermission();
      return this.permission === 'granted';
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      return false;
    }
  }

  isPermissionGranted() {
    return this.supported && Notification.permission === 'granted';
  }

  showNotification(title, options = {}) {
    if (!this.isPermissionGranted()) {
      console.warn('Notification permission not granted');
      return null;
    }

    const defaultOptions = {
      icon: '/favicon.ico',
      badge: '/favicon.ico',
      tag: 'fgs-admin-notification',
      requireInteraction: false,
      silent: false,
      ...options
    };

    try {
      const notification = new Notification(title, defaultOptions);
      
      notification.onclick = (event) => {
        event.preventDefault();
        window.focus();
        notification.close();
        
        // Navigate to admin if URL provided
        if (options.data?.url) {
          window.location.href = options.data.url;
        }
      };

      // Auto close after 10 seconds
      setTimeout(() => notification.close(), 10000);

      return notification;
    } catch (error) {
      console.error('Error showing notification:', error);
      return null;
    }
  }

  // Show order notification
  showOrderNotification(order) {
    return this.showNotification('🛒 Nouvelle commande', {
      body: `${order.customer_name || 'Client'} - ${order.total_amount?.toFixed(2) || 0}€`,
      tag: `order-${order.order_id}`,
      data: { url: '/admin?tab=orders' },
      vibrate: [200, 100, 200]
    });
  }

  // Show quote notification
  showQuoteNotification(quote) {
    return this.showNotification('📋 Nouvelle demande de devis', {
      body: `${quote.name || 'Client'} - ${quote.category || 'Pro'}`,
      tag: `quote-${quote.quote_id}`,
      data: { url: '/admin?tab=quotes' },
      vibrate: [200, 100, 200]
    });
  }
}

export const pushService = new PushNotificationService();
export default pushService;
